/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPNEED = {
    Guarantee: '1',
    CapitalProtection: '2',
    AccessToInvestment: '3'
} as const;
export type IAPNEED = typeof IAPNEED[keyof typeof IAPNEED];


export function IAPNEEDFromJSON(json: any): IAPNEED {
    return IAPNEEDFromJSONTyped(json, false);
}

export function IAPNEEDFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPNEED {
    return json as IAPNEED;
}

export function IAPNEEDToJSON(value?: IAPNEED | null): any {
    return value as any;
}

